import { formaters } from "vincent-utils";
import _ from "underts";
export default function (plage, dureeMiniRdv) {
    const startInMinutes = formaters.getHourAsMinutesFromHMObject(plage.start);
    const endInMinutes = formaters.getHourAsMinutesFromHMObject(plage.end);
    return _.compact(_.range(startInMinutes, endInMinutes, dureeMiniRdv).map(formaters.getHourMinutesFromMinutes));
}
//# sourceMappingURL=sliceHM.js.map